/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Hc_Domains_Answer_1Inputs */

const en_hc_domains_answer_1 = /** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every seller gets a free subdomain at ${i?.url}.`)
};

const es_hc_domains_answer_1 = /** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cada vendedor obtiene un subdominio gratuito en ${i?.url}.`)
};

const fr_hc_domains_answer_1 = /** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chaque vendeur obtient un sous-domaine gratuit à ${i?.url}.`)
};

const de_hc_domains_answer_1 = /** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jeder Verkäufer erhält eine kostenlose Subdomain unter ${i?.url}.`)
};

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const ja_hc_domains_answer_1 = en_hc_domains_answer_1;

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const zh_hc_domains_answer_1 = en_hc_domains_answer_1;

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const ar_hc_domains_answer_1 = en_hc_domains_answer_1;

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const id_hc_domains_answer_1 = en_hc_domains_answer_1;

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const it_hc_domains_answer_1 = en_hc_domains_answer_1;

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const ru_hc_domains_answer_1 = en_hc_domains_answer_1;

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const pt_hc_domains_answer_1 = en_hc_domains_answer_1;

/** @type {(inputs: Hc_Domains_Answer_1Inputs) => LocalizedString} */
const ko_hc_domains_answer_1 = en_hc_domains_answer_1;

/**
* | output |
* | --- |
* | "Every seller gets a free subdomain at {url}." |
*
* @param {Hc_Domains_Answer_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hc_domains_answer_1 = /** @type {((inputs: Hc_Domains_Answer_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hc_Domains_Answer_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hc_domains_answer_1(inputs)
	if (locale === "es") return es_hc_domains_answer_1(inputs)
	if (locale === "fr") return fr_hc_domains_answer_1(inputs)
	if (locale === "de") return de_hc_domains_answer_1(inputs)
	if (locale === "ja") return ja_hc_domains_answer_1(inputs)
	if (locale === "zh") return zh_hc_domains_answer_1(inputs)
	if (locale === "ar") return ar_hc_domains_answer_1(inputs)
	if (locale === "id") return id_hc_domains_answer_1(inputs)
	if (locale === "it") return it_hc_domains_answer_1(inputs)
	if (locale === "ru") return ru_hc_domains_answer_1(inputs)
	if (locale === "pt") return pt_hc_domains_answer_1(inputs)
	return ko_hc_domains_answer_1(inputs)
});